/**
 * A ONDA. Pano de fundo da entrada do Notes.
 *
 * Regra da casa (23/08): mesmo conceito de entrada da suíte, animação PRÓPRIA
 * por produto. Pessoas é a constelação (rede de gente), MKT é a jornada, CRM é
 * o mapa de rotas. O Notes é a CONVERSA VIRANDO REGISTRO: à esquerda, linhas
 * de áudio ondulando (a fala); no meio, elas se acalmam; à direita, viram
 * linhas retas de texto, com um ponto aceso onde nasceu um compromisso.
 *
 * SVG e CSS puros. Numa tela de login cada quilobyte de JavaScript atrasa o
 * primeiro campo ficar utilizável.
 */
type Linha = { y: number; amp: number; freq: number; atraso: number; dur: number; marco?: number };

/** Posições FIXAS, compostas: a faixa superior e a diagonal ficam com a onda; o
 * canto inferior esquerdo fica livre para a frase. */
const LINHAS: Linha[] = [
  { y: 14, amp: 6,  freq: 1.6, atraso: 0,    dur: 5200, marco: 88 },
  { y: 22, amp: 9,  freq: 1.2, atraso: 300,  dur: 6000 },
  { y: 30, amp: 5,  freq: 2.1, atraso: 600,  dur: 4800, marco: 79 },
  { y: 38, amp: 11, freq: 0.9, atraso: 150,  dur: 6600 },
  { y: 46, amp: 7,  freq: 1.5, atraso: 900,  dur: 5600, marco: 92 },
  { y: 54, amp: 4,  freq: 2.4, atraso: 450,  dur: 5000 },
  { y: 62, amp: 8,  freq: 1.1, atraso: 1200, dur: 6200, marco: 84 },
];

/** Caminho que ONDULA até x=52 e vira RETA de 60 em diante, com um trecho de calma no meio. */
function caminho(l: Linha): string {
  const pontos: string[] = [];
  for (let x = 6; x <= 94; x += 1) {
    const peso = x < 44 ? 1 : x < 60 ? 1 - (x - 44) / 16 : 0;   // a onda se acalma
    const y = l.y + Math.sin((x / 100) * Math.PI * 2 * l.freq * 3) * l.amp * peso;
    pontos.push(`${x === 6 ? "M" : "L"}${x.toFixed(2)},${y.toFixed(2)}`);
  }
  return pontos.join(" ");
}

export function Onda() {
  return (
    <svg className="enotes-onda" viewBox="0 0 100 100" preserveAspectRatio="none" aria-hidden="true">
      <defs>
        <linearGradient id="enotes-onda-tinta" x1="0" y1="0" x2="1" y2="0">
          <stop offset="0" stopColor="var(--accent-strong)" stopOpacity="0.35" />
          <stop offset="0.55" stopColor="var(--accent-strong)" stopOpacity="0.9" />
          <stop offset="1" stopColor="var(--foreground)" stopOpacity="0.55" />
        </linearGradient>
      </defs>
      {LINHAS.map((l, i) => (
        <g key={i}>
          <path
            d={caminho(l)} className="enotes-onda-linha" pathLength={100}
            style={{ animationDelay: `${l.atraso}ms`, animationDuration: `${l.dur}ms` }}
          />
          {/* O pulso que percorre a linha: a informação passando da fala para o registro. */}
          <path
            d={caminho(l)} className="enotes-onda-pulso" pathLength={100}
            style={{ animationDelay: `${l.atraso + 400}ms`, animationDuration: `${l.dur}ms` }}
          />
          {l.marco !== undefined && (
            <circle cx={l.marco} cy={l.y} r={0.9} className="enotes-onda-marco"
              style={{ animationDelay: `${l.atraso + l.dur * 0.7}ms`, animationDuration: `${l.dur}ms` }} />
          )}
        </g>
      ))}
    </svg>
  );
}
